import { httpClient, postProcessUpsert } from "@genai/http-client";
import { OrganizationId, EditOrganizationForm, Organization } from "../model";

export function editOrganization(
  organizationId: OrganizationId,
  editOrganizationForm: EditOrganizationForm,
) {
  return httpClient(`/organizations/${organizationId}`, {
    method: "PUT",
    body: JSON.stringify(editOrganizationForm),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(postProcessUpsert)
    .then((organization) => organization as Organization);
}
